module.exports = __webpack_public_path__ + "static/image/logo-family/logo_bmart@2x.png?fd949c17";